import { action } from 'typesafe-actions';
import { Action } from 'redux';

import { CaptchaActionsEnum } from '../enums/CaptchaActionsEnum';

export const captchaSetError = (error: string) => action(CaptchaActionsEnum.CAPTCHA_SET_ERROR, { error });
export const captchaSetIsActive = (value: boolean) => action(CaptchaActionsEnum.CAPTCHA_SET_IS_ACTIVE, { value });
export const captchaLoad = (captchaInputValue: string, onTokenLoad?: () => void) =>
  action(CaptchaActionsEnum.CAPTCHA_LOAD, { captchaInputValue, onTokenLoad });
export const captchaRequest = () => action(CaptchaActionsEnum.CAPTCHA_REQUEST);
export const captchaSuccess = (token: string) => action(CaptchaActionsEnum.CAPTCHA_SUCCESS, { token });
export const captchaSetImage = (image: string) => action(CaptchaActionsEnum.CAPTCHA_SET_IMAGE, { image });
export const captchaGetImage = () => action(CaptchaActionsEnum.CAPTCHA_GET_IMAGE);
export const captchaReset = () => action(CaptchaActionsEnum.CAPTCHA_RESET);
export const captchaSetActionAfterTokenLoad = (func: () => Action<unknown>) =>
  action(CaptchaActionsEnum.CAPTCHA_SET_ACTION_AFTER_LOAD, { func });
export const captchaGetAudio = () => action(CaptchaActionsEnum.CAPTCHA_GET_AUDIO);
export const captchaSetAudio = (audio: string) => action(CaptchaActionsEnum.CAPTCHA_SET_AUDIO, { audio });
